import { gql } from "@apollo/client";

export const WalletConnection = gql`
mutation WalletConnectionMutation(
        $walletAddress: String
    ) {
        walletConnectionMutation(
            walletAddress: $walletAddress,
        ) {
            user {
                id
                email
                verified
                blocked
                walletAddress
            }
            message
            res
        }
    }
`;